import React from 'react';
export var ImageItem = function ImageItem(props) {
  var value = props.value;
  var imageUrl = value.imageUrl,
    imageHeight = value.imageHeight,
    imageWidth = value.imageWidth;
  if (!imageUrl) {
    return React.createElement(React.Fragment, null);
  }
  var ratio = imageWidth / imageHeight;
  var style = {
    height: ratio > 1 ? '100%' : 'auto',
    width: ratio > 1 ? 'auto' : '100%'
  };
  return React.createElement("div", {
    style: {
      width: '100%',
      height: '100%',
      overflow: 'hidden'
    }
  }, React.createElement("img", {
    src: imageUrl,
    style: style
  }));
};